import React from 'react';
import { connect } from 'react-redux';
import {
  LoaderBlock,
  EditButton,
  Img,
  ButtonBlock,
  DishTitleLabel,
  DeleteButton,
} from '../CreateTrainingList/TrainingList';
import * as action from '../../../actions/newYouslim';
import VideoModal from '../../Videos/VideoModal';
import {
  FirstBlock,
  Label,
  Content,
  DishCountBlock,
  H1,
  TypeComplexityBlock,
  Block,
  Item,
  H2,
  PeriodLabel,
  TableBlock,
  PlayButton,
  NameBlock,
} from './TrainingCourse';

import { toastError } from '../../../utils/toastMessage';
import { defaultValue, defaultComplexity, defaultTemplate } from '../youslim2.0_Constants';
import { Input, TextArea, Form, Dropdown, Button, Table, Loader } from 'semantic-ui-react';
import EditIcon from '../../../images/edit_icon.png';
import Navbar from '../Navigation/Navbar';

const TrainingCourse = ({
  match,
  getTraining,
  getTrainingTemplateId,
  updateUserTrainingCourse,
  trainingTemplate,
  isTrainingLoading,
  training,
  setCurrentTraining,
  getUserTrainingCourse,
  userTrainingCourse,
  trainingTemplateId,
  setIsVideoModalOpen,
  setActiveVideo,
  isVideoModalOpen,
  activeVideo,
  params,
  getUser,
  userInfo,
}) => {
  const [newUserId, setNewUserId] = React.useState(0);
  const [userName, setUserName] = React.useState('');
  const [name, setName] = React.useState('');
  const [type, setType] = React.useState('');
  const [complex, setComplexity] = React.useState('');
  const [duration, setDuration] = React.useState(0);
  const [typeTraining, setTypeTraining] = React.useState(defaultValue);
  const [templateType, setTemplateType] = React.useState('');
  const [templateComplexity, setTemplateComplexity] = React.useState('');
  const [trainingComplexity, setTrainingComplexity] = React.useState(defaultComplexity);
  const [trainingFromList, setTrainingFromList] = React.useState([]);
  const [trainingTemplateList, setTrainTemplateList] = React.useState([]);

  const [trainingValue, setTrainingValue] = React.useState([]);

  const [newTrainingList, setNewTrainingList] = React.useState([]);
  const [userCourseId, setUserCourseId] = React.useState(0);
  const [isCreateTemplate, setIsCreateTemplate] = React.useState(false);
  const [newDescription, setNewDescription] = React.useState('');
  const [countTrainings, setCountTrainings] = React.useState(0);
  const [trainingTemplateIdList, setTrainingTemplateIdList] = React.useState([
    {
      period: 0,
      training_video: {
        title: '',
        type_video_training: { name: '' },
        complexity_training: { name: '' },
        duration: 0,
        video_file: { url: '', id: 0 },
        id: 0,
      },
    },
  ]);

  React.useEffect(() => {
    getTraining();
  }, []);

  React.useEffect(() => {
    if (match && match.params && match.params.courseId) {
      getUserTrainingCourse(match.params.courseId);
    }
  }, []);

  React.useEffect(() => {
    userInfo && userInfo.name ? setUserName(userInfo.name) : setUserName('');
    userInfo && userInfo.id ? setNewUserId(userInfo.id) : setNewUserId('');
  }, [userInfo]);

  React.useEffect(() => {
    userTrainingCourse && userTrainingCourse.id
      ? setUserCourseId(userTrainingCourse.id)
      : setUserCourseId('');
    userTrainingCourse && userTrainingCourse.name ? setName(userTrainingCourse.name) : setName('');
    userTrainingCourse && userTrainingCourse.type_template
      ? setTemplateType(userTrainingCourse.type_template.name)
      : setTemplateType('');
    userTrainingCourse && userTrainingCourse.complexity
      ? setTemplateComplexity(userTrainingCourse.complexity.name)
      : setTemplateComplexity('');

    userTrainingCourse && userTrainingCourse.count_trainings_on_week
      ? setCountTrainings(userTrainingCourse.count_trainings_on_week)
      : setCountTrainings('');
    userTrainingCourse && userTrainingCourse.description
      ? setNewDescription(userTrainingCourse.description)
      : setNewDescription('');

    if (userTrainingCourse && userTrainingCourse.trainings) {
      const newTrainingList = userTrainingCourse.trainings;
      const trainingListWithEmptyDays = [];
      newTrainingList.forEach((element, index) => {
        if (index === 0) {
          for (let i = 0; i < element.period; i++) {
            trainingListWithEmptyDays.push({
              period: i,
              training_video: {
                title: '',
                type_video_training: { name: '' },
                complexity_training: { name: '' },
                duration: 0,
                video_file: { url: '', id: 0 },
                id: 0,
              },
            });
          }
        }
        trainingListWithEmptyDays.push(element);
        if (index < newTrainingList.length - 1) {
          if (element.period !== newTrainingList[index + 1].period - 1) {
            let emptyDaysCount = newTrainingList[index + 1].period - 1 - element.period;
            for (let i = 0; i < emptyDaysCount; i++) {
              trainingListWithEmptyDays.push({
                period: element.period + 1,
                training_video: {
                  title: '',
                  type_video_training: { name: '' },
                  complexity_training: { name: '' },
                  duration: 0,
                  video_file: { url: '', id: 0 },
                  id: 0,
                },
              });
            }
          }
          return;
        }
      }),
        setTrainingTemplateIdList([...trainingListWithEmptyDays]);
    }
  }, [userTrainingCourse]);

  React.useEffect(() => {
    if (match && match.params && match.params.id) {
      getUser(match.params.id);
    }
  }, [match]);

  React.useEffect(() => {
    const newTemplateArr = [];
    trainingTemplate.map((item) => {
      newTemplateArr.push({
        id: item.id,
        key: item.id,
        value: item.name,
        text: item.name,
        count_trainings_on_week: item.count_trainings_on_week,
        if(type_template) {
          item.type_template.name;
        },
        if(complexity) {
          item.complexity.name;
        },
      });
    });
    setTrainTemplateList([...newTemplateArr]);
  }, [trainingTemplate]);

  React.useEffect(() => {
    const newTrainingList = [];
    training.map((train) => {
      newTrainingList.push({
        key: train.id,
        id: train.id,
        value: train.title,
        text: train.title,
        training_video_id: train.id,
        period: 0,
        video_file: train && train.video_file && train.video_file.url ? train.video_file.url : '',
      });
    });
    setNewTrainingList([...newTrainingList]);
  }, [training]);

  const onSave = React.useCallback(() => {
    const trainingListToSave = [];
    trainingTemplateIdList.map((training) => {
      if (training.training_video.id !== 0) {
        trainingListToSave.push({
          training_video_id: training.training_video.id,
          period: training.period,
        });
      }
    });
    const templateForRequest = {
      description: newDescription,
      trainings: trainingListToSave,
    };
    updateUserTrainingCourse(templateForRequest, userCourseId);
  });

  const onEditClick = React.useCallback(
    (training) => {
      setCurrentTraining(training);
    },
    [setCurrentTraining],
  );
  const onClear = React.useCallback(() => {
    setCountTrainings(0);
    setNewDescription('');
    setTrainingTemplateIdList([
      {
        period: 1,
        training_video: {
          title: '',
          type_video_training: { name: '' },
          complexity_training: { name: '' },
          duration: 0,
          video_file: { url: '', id: 0 },
          id: 0,
        },
      },
    ]);
    setTrainingComplexity('');
    setTypeTraining('');
    setTrainingValue('');
    setComplexity('');
    setDuration(0);
    setType('');
    setUserName('');
    setName('');
    setNewUserId('');
  }, []);

  const showVideo = React.useCallback(
    (video) => {
      setIsVideoModalOpen(true);
      setActiveVideo(video);
    },
    [setIsVideoModalOpen, setActiveVideo],
  );
  const addTraining = React.useCallback(() => {
    setTrainingTemplateIdList([
      ...trainingTemplateIdList,
      {
        period: isCreateTemplate
          ? trainingTemplateIdList.length + 1
          : trainingTemplateIdList.length,
        training_video: {
          title: '',
          type_video_training: { name: '' },
          complexity_training: { name: '' },
          duration: 0,
          video_file: { url: '', id: 0 },
          id: 0,
        },
      },
    ]);
  }, [trainingTemplateIdList, setTrainingTemplateIdList]);

  const deleteTraining = (index) => {
    const newTrainingList = trainingTemplateIdList;
    newTrainingList.pop(index, 1);
    setTrainingTemplateIdList([...newTrainingList]);
  };

  const selectTemplateType = (data) => {
    setTemplateType(data.value);
  };

  const selectTrainingFromList = (data, index) => {
    const trainingData = training.find((trainingData) => trainingData.title === data.value);
    const newTrainingList = trainingTemplateIdList;
    newTrainingList[index].training_video.title = data.value;

    newTrainingList[index].training_video.type_video_training.name =
      trainingData.type_video_training.name;
    newTrainingList[index].training_video.complexity_training.name =
      trainingData.complexity_training.name;
    newTrainingList[index].training_video.duration = trainingData.duration;
    newTrainingList[index].training_video.video_file.url = trainingData.video_file.url;
    newTrainingList[index].training_video.video_file.id = trainingData.video_file.id;
    newTrainingList[index].training_video.id = trainingData.id;

    setTrainingTemplateIdList([...newTrainingList]);
  };

  const onSetTrainingPeriod = (data, index) => {
    const newTrainingList = trainingTemplateIdList;
    newTrainingList[index].period = data;
    setTrainingTemplateIdList([...newTrainingList]);
  };

  const clearField = (index) => {
    const newList = trainingTemplateIdList.map((training, trainingIndex) => {
      if (trainingIndex === index) {
        return {
          period: +training.period,
          training_video: {
            title: '',
            type_video_training: { name: '' },
            complexity_training: { name: '' },
            duration: 0,
            video_file: { url: '', id: 0 },
            id: 0,
          },
        };
      }
      return training;
    });
    setTrainingTemplateIdList([...newList]);
  };

  return (
    <React.Fragment>
      <Navbar />
      <H1>
        id {newUserId} | пользователь {userName}
      </H1>
      <H2> {name}</H2>

      <Content>
        <TypeComplexityBlock>
          <Block>
            <Label>Тип</Label>
            <Item>
              <Input
                disabled
                placeholder="Тип шаблона"
                value={templateType}
                onChange={(e, data) => selectTemplateType(data)}
              />
            </Item>
          </Block>
          <Block>
            <Label>Сложность</Label>
            <Item>
              <Input placeholder="сложность" disabled value={templateComplexity} />
            </Item>
          </Block>
          <Block>
            <Label> Кол-во тренировок в неделю</Label>
            <Input
              type="number"
              min="0"
              max="7"
              placeholder="Введите число"
              disabled
              className="template-name-input"
              style={{ width: '80px', height: '42px' }}
              value={countTrainings}
            />
          </Block>
        </TypeComplexityBlock>
        <Block>
          <Label> Описание</Label>
          <Item>
            <Form>
              <Form.Field
                control={TextArea}
                placeholder="Введите описание тренировки"
                style={{ minWidth: '505px', height: '100px' }}
                value={newDescription}
                maxLength="200"
                onChange={(event) => setNewDescription(event.target.value)}
                rows={1}
              />
            </Form>
          </Item>
        </Block>

        <DishCountBlock>
          <H2>Состав шаблона курса </H2>
        </DishCountBlock>
        <TableBlock>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>
                  <DishTitleLabel>
                    Номер дня <br />
                  </DishTitleLabel>
                </Table.HeaderCell>
                <Table.HeaderCell>Название тренировки</Table.HeaderCell>
                <Table.HeaderCell>Тип</Table.HeaderCell>
                <Table.HeaderCell>Сложность</Table.HeaderCell>
                <Table.HeaderCell style={{ width: '40%', margin: 0 }}>
                  Длительность
                </Table.HeaderCell>
                <Table.HeaderCell>Видео</Table.HeaderCell>
                <Table.HeaderCell collapsing>
                  <ButtonBlock>
                    <PlayButton
                      style={{ margin: '0px auto', backgroundColor: 'blue' }}
                      onClick={addTraining}
                    >
                      +
                    </PlayButton>
                    <PlayButton onClick={deleteTraining}>-</PlayButton>
                  </ButtonBlock>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {trainingTemplateIdList &&
                trainingTemplateIdList.map((training, index) => {
                  return (
                    <Table.Row>
                      <React.Fragment>
                        <Table.Cell>
                          <NameBlock>
                            <PeriodLabel
                              type="number"
                              onChange={(event) => onSetTrainingPeriod(event.target.value, index)}
                            >
                              {isCreateTemplate ? training.period : training.period + 1}
                            </PeriodLabel>
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                          <NameBlock>
                            <Dropdown
                              openOnFocus
                              search
                              selection
                              placeholder="выберите тренировку"
                              options={newTrainingList}
                              value={training.training_video.title}
                              onChange={(e, data) => selectTrainingFromList(data, index)}
                              style={{ width: '325px' }}
                            />
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                          <NameBlock style={{ width: '85px' }}>
                            <Input
                              type="text"
                              placeholder="тип"
                              disabled
                              value={training.training_video.type_video_training.name}
                              onChange={(event) => setType(event.target.value)}
                              style={{ width: '85px' }}
                            />
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                          <NameBlock>
                            <Input
                              type="text"
                              placeholder="сложность"
                              disabled
                              value={training.training_video.complexity_training.name}
                              onChange={(event) => setComplexity(event.target.value)}
                              style={{ width: '120px' }}
                            />
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9', width: '40%' }}>
                          <NameBlock style={{ width: '100px' }}>
                            <Input
                              type="number"
                              placeholder="длительность"
                              disabled
                              value={training.training_video.duration}
                              onChange={(event) => setDuration(event.target.value)}
                              style={{ width: '100%' }}
                            />
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell style={{ borderLeft: '0.5px solid #e8e9e9' }}>
                          <NameBlock>
                            <PlayButton
                              style={{ margin: '0px auto' }}
                              onClick={() => showVideo(training.training_video.video_file.url)}
                              setIsVideoModalOpen={true}
                            >
                              ▶
                            </PlayButton>
                          </NameBlock>
                        </Table.Cell>
                        <Table.Cell>
                          <ButtonBlock>
                            <EditButton
                              onClick={() => onEditClick(training)}
                              to={`/youslim2.0/CreateTraining/${
                                !isCreateTemplate
                                  ? training.training_video.id
                                  : training.training_video.video_file.id
                              }/edit`}
                              target="_blank"
                            >
                              <Img src={EditIcon} alt="edit" />
                            </EditButton>
                            <DeleteButton onClick={() => clearField(index)}> x</DeleteButton>
                          </ButtonBlock>
                        </Table.Cell>
                      </React.Fragment>
                    </Table.Row>
                  );
                })}
            </Table.Body>
          </Table>
        </TableBlock>
        <Button
          color="green"
          style={{
            margin: '0px auto',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '30px',
          }}
          onClick={onSave}
          loading={isTrainingLoading}
        >
          Обновить
        </Button>
        <VideoModal
          isModalOpen={isVideoModalOpen}
          setIsModalOpen={setIsVideoModalOpen}
          activeVideo={activeVideo}
        />
      </Content>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const {
    complexity,
    trainingType,
    trainingTemplate,
    trainingTemplateId,
    training,
    isTrainingLoading,
    isVideoModalOpen,
    userTrainingCourse,
    user,
    userInfo,
  } = state.newYouslim;
  return {
    complexity,
    trainingType,
    trainingTemplate,
    trainingTemplateId,
    training,
    isVideoModalOpen,
    isTrainingLoading,
    userTrainingCourse,
    user,
    userInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTrainingTemplate: () => {
      dispatch(action.getTrainingTemplate());
    },
    getTrainingTemplateId: (id) => {
      dispatch(action.getTrainingTemplateId(id));
    },
    getTraining: () => {
      dispatch(action.getTraining());
    },
    setIsVideoModalOpen: (isOpen) => {
      dispatch(action.setIsVideoModalOpen(isOpen));
    },
    setActiveVideo: (activeVideo) => {
      dispatch(action.setActiveVideo(activeVideo));
    },
    setCurrentTraining: (training) => {
      dispatch(action.setCurrentTraining(training));
    },
    getUserTrainingCourse: (id) => {
      dispatch(action.getUserTrainingCourse(id));
    },
    updateUserTrainingCourse: (data, id) => {
      dispatch(action.updateUserTrainingCourse(data, id));
    },
    getUser: (userId) => {
      dispatch(action.getUser(userId));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TrainingCourse);



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TrainingCourse/index.jsx